import { hc } from 'hono/client';
import type { AppType } from '@vendorops/backend';

// In dev, Vite proxies /api to the backend (vite.config.ts), so a relative
// base URL works. In production the frontend (Vercel) and backend (Railway)
// live on different origins — VITE_API_URL points the client at the backend.
const baseURL = import.meta.env.VITE_API_URL || '/';

export const client = hc<AppType>(baseURL, {
  init: { credentials: 'include' },
});
